import gql from 'graphql-tag';

const updateEventDateTimeMutation = gql`
  mutation updateEventDateTimeMutation($_id: MongoID!, $dateTime: [Date]) {
    updateByIdEventMutation(_id: $_id, record: { dateTime: $dateTime }) {
      record {
        _id
        title
        dateTime
        color
        status
      }
    }
  }
`;

export default updateEventDateTimeMutation;
